import { render, staticRenderFns } from "./TextStyle.vue?vue&type=template&id=945866fc&"
import script from "./TextStyle.vue?vue&type=script&lang=js&"
export * from "./TextStyle.vue?vue&type=script&lang=js&"
import style0 from "./TextStyle.vue?vue&type=style&index=0&id=945866fc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports